import CloseRounded from '@mui/icons-material/CloseRounded';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import * as React from 'react';

export default function InsetDrawer({
  open,
  onClose,
  title,
  content,
  width = 800,
  anchor = 'right',
}) {
  const toggle = (next) => () => onClose(next);

  return (
    <Box className="min-h-screen w-full bg-neutral-50 flex items-center justify-center p-6">
      <Drawer
        anchor={anchor}
        open={open}
        onClose={toggle(false)}
        hideBackdrop={false}
        ModalProps={{ keepMounted: true }}
        PaperProps={{
          sx: (theme) => ({
            m: { xs: 1, sm: 2 },
            maxWidth: width,
            width:
              anchor === 'left' || anchor === 'right'
                ? {
                    xs: `calc(100% - ${theme.spacing(2)})`,
                    sm: `calc(100% - ${theme.spacing(2)})`,
                    xl: `calc(100% - ${theme.spacing(2)})`,
                  }
                : undefined,
            height:
              anchor === 'top' || anchor === 'bottom'
                ? {
                    xs: `calc(100% - ${theme.spacing(2)})`,
                    sm: `calc(100% - ${theme.spacing(4)})`,
                  }
                : `calc(100% - ${theme.spacing(4)})`,
            borderRadius: 3,
            boxShadow: 24,
            overflow: 'hidden',
          }),
        }}
      >
        <DrawerContent
          onClose={toggle(false)}
          title={title}
          content={content}
        />
      </Drawer>
    </Box>
  );
}

function DrawerContent({ onClose, title = 'Inset Drawer', content }) {
  return (
    <Box
      role="presentation"
      sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 2,
        }}
      >
        <Typography variant="h6" fontWeight={700}>
          {title}
        </Typography>
        <IconButton onClick={onClose} aria-label="Close">
          <CloseRounded />
        </IconButton>
      </Box>
      <Divider />
      <Box sx={{ p: 2, flex: 1 }}>{content}</Box>
    </Box>
  );
}
